
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/courses",
      function () {
        return require("private-next-pages/next/courses/index.tsx");
      }
    ]);
  